import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AlertFacadeService, AppAlert } from '@rogers/self-serve-common/alert';
import { Observable } from 'rxjs';
import { GetPageAlert } from './state/actions';

@Injectable({
  providedIn: 'root',
})
export class PageAlertFacadeService {
  constructor(
    private alertFacadeService: AlertFacadeService,
    private store: Store,
  ) {}

  getPageAlerts$(page: string): Observable<AppAlert> {
    return this.alertFacadeService.getPageAlerts$('page', page);
  }

  loadPageAlerts(page: string) {
    this.store.dispatch(new GetPageAlert(page));
  }
}
